import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/Test.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/OcrLog",
    name: "OcrLog",
    component: () => import("../views/ErrMsg/OcrLog.vue"),
  },
  {
    path: "/PortalIndex",
    name: "PortalIndex",
    component: () => import("../views/PortalSite/Index.vue"),
  },
  {
    path: "/PrizeDraw",
    name: "PrizeDraw",
    component: () => import("../views/PrizeDraw/PrizeDraw.vue"),
  },
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue'),
    children: [{
      path: 'Index',
      name: 'Index', //首页
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Index/Index.vue')
    }, {
      path: 'Board',
      name: 'Board', //看板
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Index/Board.vue')
    }, {
      path: 'SaleOutbound',
      name: 'SaleOutbound', //销售出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/SaleOutbound.vue')
    }, {
      path: 'ScrapedOutbound',
      name: 'ScrapedOutbound', //坏件出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/ScrapedOutbound.vue')
    }, {
      path: 'ReturnOutbound',
      name: 'ReturnOutbound', //退货出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/ReturnOutbound.vue')
    }, {
      path: 'AllotOutbound',
      name: 'AllotOutbound', //调拨出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/AllotOutbound.vue')
    }, {
      path: 'OtherOutbound',
      name: 'OtherOutbound', //其他出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/OtherOutbound.vue')
    }, {
      path: 'QuotationManage',
      name: 'QuotationManage', //报价管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Outbound/QuotationManage.vue')
    }, {
      path: 'BuyInbound',
      name: 'BuyInbound', //采购入库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Inbound/BuyInbound.vue')
    }, {
      path: 'ReturnInbound',
      name: 'ReturnInbound', //退货入库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Inbound/ReturnInbound.vue')
    }, {
      path: 'AllotInbound',
      name: 'AllotInbound', //调拨入库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Inbound/AllotInbound.vue')
    }, {
      path: 'OtherInbound',
      name: 'OtherInbound', //其他入库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Inbound/OtherInbound.vue')
    }, {
      path: 'BuyPlain',
      name: 'BuyPlain', //采购计划
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Inbound/BuyPlain.vue')
    }, {
      path: 'StoreSearch',
      name: 'StoreSearch', //库存查询
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/StoreSearch.vue')
    }, {
      path: 'StoreTransfer',
      name: 'StoreTransfer', //库存调拨
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/StoreTransfer.vue')
    }, {
      path: 'StoreInventory',
      name: 'StoreInventory', //库存盘点
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/StoreInventory.vue')
    }, {
      path: 'StoreWarn',
      name: 'StoreWarn', //库存预警
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/StoreWarn.vue')
    }, {
      path: 'BrokenManage',
      name: 'BrokenManage', //坏件管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/BrokenManage.vue')
    }, {
      path: 'StoreTurnover',
      name: 'StoreTurnover', //库存流水
      meta: {
        keepAlive: true
      },
      component: () => import('../views/StoreManage/StoreTurnover.vue')
    }, {
      path: 'OutboundTurnover',
      name: 'OutboundTurnover', //出库流水
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/OutboundTurnover.vue')
    }, {
      path: 'InboundTurnover',
      name: 'InboundTurnover', //入库流水
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/InboundTurnover.vue')
    }, {
      path: 'Reimbursement',
      name: 'Reimbursement', //报销单
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/Reimbursement.vue')
    }, {
      path: 'BookkeepingVoucher',
      name: 'BookkeepingVoucher', //记账凭证
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/BookkeepingVoucher.vue')
    }, {
      path: 'IncomeStatement',
      name: 'IncomeStatement', //利润表
      component: () => import('../views/Finance/IncomeStatement.vue')
    }, {
      path: 'BalanceSheet',
      name: 'BalanceSheet', //资产负债表
      component: () => import('../views/Finance/BalanceSheet.vue')
    }, {
      path: 'CashFlow',
      name: 'CashFlow', //现金流量表
      component: () => import('../views/Finance/CashFlow.vue')
    }, {
      path: 'AccountBalance',
      name: 'AccountBalance', //科目余额表
      component: () => import('../views/Finance/AccountBalance.vue')
    }, {
      path: 'AccountDetails',
      name: 'AccountDetails', //科目明细表
      component: () => import('../views/Finance/AccountDetails.vue')
    }, {
      path: 'SupplierInformation',
      name: 'SupplierInformation', //供应商信息
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/SupplierInformation.vue')
    }, {
      path: 'CustomerInformation',
      name: 'CustomerInformation', //客户信息
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/CustomerInformation.vue')
    }, {
      path: 'ProductCategory',
      name: 'ProductCategory', //商品类别
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/ProductCategory.vue')
    }, {
      path: 'ProductInformation',
      name: 'ProductInformation', //商品信息
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/ProductInformation.vue')
    }, {
      path: 'ProductBatch',
      name: 'ProductBatch', //商品批次
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/ProductBatch.vue')
    }, {
      path: 'ProductDismounting',
      name: 'ProductDismounting', //商品拆装
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/ProductDismounting.vue')
    }, {
      path: 'DismountRecord',
      name: 'DismountRecord', //拆装记录
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/DismountRecord.vue')
    }, {
      path: 'WarehouseLocation',
      name: 'WarehouseLocation', //库位管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/BasicInformation/WarehouseLocation.vue')
    }, {
      path: 'OutboundSummary',
      name: 'OutboundSummary', //出库商品汇总
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/OutboundSummary.vue')
    }, {
      path: 'OutboundSummaryFinance',
      name: 'OutboundSummaryFinance', //出库商品汇总(财务)
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/OutboundSummaryFinance.vue')
    }, {
      path: 'OutboundStatistics',
      name: 'OutboundStatistics', //出库商品明细
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/OutboundStatistics.vue')
    }, {
      path: 'OutboundStatisticsFinance',
      name: 'OutboundStatisticsFinance', //出库商品明细(财务)
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Finance/OutboundStatisticsFinance.vue')
    }, {
      path: 'InboundSummary',
      name: 'InboundSummary', //入库商品汇总
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/InboundSummary.vue')
    }, {
      path: 'InboundStatistics',
      name: 'InboundStatistics', //入库商品明细
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/InboundStatistics.vue')
    }, {
      path: 'AccountsReceivable',
      name: 'AccountsReceivable', //应收账款
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/AccountsReceivable.vue')
    }, {
      path: 'AccountsPayable',
      name: 'AccountsPayable', //应付账款
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/AccountsPayable.vue')
    }, {
      path: 'InventoryCost',
      name: 'InventoryCost', //库存成本统计
      meta: {
        keepAlive: true
      },
      component: () => import('../views/DataStatistics/InventoryCost.vue')
    }, {
      path: 'UserManage',
      name: 'UserManage', //员工管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/UserManage.vue')
    }, {
      path: 'RoleManage',
      name: 'RoleManage', //角色管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/RoleManage.vue')
    }, {
      path: 'CompanyManage',
      name: 'CompanyManage', //公司管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/CompanyManage.vue')
    }, {
      path: 'StoreManage',
      name: 'StoreManage', //仓库管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/StoreManage.vue')
    }, {
      path: 'OrderAdjust',
      name: 'OrderAdjust', //单据调整
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/OrderAdjust.vue')
    }, {
      path: 'MenuManage',
      name: 'MenuManage', //菜单管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/MenuManage.vue')
    }, {
      path: 'LogManage',
      name: 'LogManage', //日志管理
      meta: {
        keepAlive: true
      },
      component: () => import('../views/SystemManage/LogManage.vue')
    }, {
      path: 'DataDictionary',
      name: 'DataDictionary', //数据字典

      component: () => import('../views/SystemManage/DataDictionary.vue')
    }, {
      path: 'DictionaryDetail',
      name: 'DictionaryDetail', //字典详情
      component: () => import('../views/SystemManage/DictionaryDetail.vue')
    }, {
      path: 'ScheduledTasks',
      name: 'ScheduledTasks', //定时任务

      component: () => import('../views/SystemManage/ScheduledTasks.vue')
    }, {
      path: 'DispatchingLog',
      name: 'DispatchingLog', //调度日志
      component: () => import('../views/SystemManage/DispatchingLog.vue')
    }, {
      path: 'SystemManage',
      name: 'SystemManage', //系统管理
      component: () => import('../views/SystemManage/SystemManage.vue')
    }, {
      path: 'VersionManage',
      name: 'VersionManage', //版本管理
      component: () => import('../views/SystemManage/VersionManage.vue')
    }, {
      path: 'RoleTemplate',
      name: 'RoleTemplate', //角色模板
      component: () => import('../views/SystemManage/RoleTemplate.vue')
    }, {
      path: 'CategorizeTemplete',
      name: 'CategorizeTemplete', //分类模板
      component: () => import('../views/SystemManage/CategorizeTemplete.vue')
    }, {
      path: 'SuggestManage',
      name: 'SuggestManage', //留言管理
      component: () => import('../views/SystemManage/SuggestManage.vue')
    }, {
      path: 'OcrManage',
      name: 'OcrManage', //ocr管理
      component: () => import('../views/SystemManage/OcrManage.vue')
    }, {
      path: 'DataUpload',
      name: 'DataUpload', //历史数据上传
      component: () => import('../views/HistoryData/DataUpload.vue')
    }, {
      path: 'DataSearch',
      name: 'DataSearch', //历史数据查询
      component: () => import('../views/HistoryData/DataSearch.vue')
    }, {
      path: 'DataMigrate',
      name: 'DataMigrate', //历史数据迁移
      component: () => import('../views/HistoryData/DataMigrate.vue')
    }, {
      path: 'ItemGrounding',
      name: 'ItemGrounding', //商品上架
      component: () => import('../views/Union/ItemGrounding.vue')
    }, {
      path: 'UnionItem',
      name: 'UnionItem', //友商商品
      component: () => import('../views/Union/UnionItem.vue')
    }, {
      path: 'UnionList',
      name: 'UnionList', //友商列表
      component: () => import('../views/Union/UnionList.vue')
    }, {
      path: 'FriendRecord',
      name: 'FriendRecord', //友商添加记录
      component: () => import('../views/Union/FriendRecord.vue')
    }, {
      path: 'UnionQuotation',
      name: 'UnionQuotation', //友商报价
      component: () => import('../views/Union/UnionQuotation.vue')
    }, {
      path: 'UniOutbound',
      name: 'UniOutbound', //友商出库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Union/UniOutbound.vue')
    }, {
      path: 'UniInbound',
      name: 'UniInbound', //友商入库
      meta: {
        keepAlive: true
      },
      component: () => import('../views/Union/UniInbound.vue')
    },{
      path: 'ManageShop',
      name: 'ManageShop', //店铺管理
      component: () => import('../views/Mall/ManageShop.vue')
    }, {
      path: 'MallGrounding',
      name: 'MallGrounding', //商城商品上架
      component: () => import('../views/Mall/MallGrounding.vue')
    }, {
      path: 'SystemMall',
      name: 'SystemMall', //系统商城
      component: () => import('../views/Mall/SystemMall.vue')
    }, {
      path: 'ShoppingCart',
      name: 'ShoppingCart', //购物车
      component: () => import('../views/Mall/ShoppingCart.vue')
    }, {
      path: 'BuyOrder',
      name: 'BuyOrder', //采购订单
      component: () => import('../views/Mall/BuyOrder.vue')
    }, {
      path: 'SaleOrder',
      name: 'SaleOrder', //销售订单
      component: () => import('../views/Mall/SaleOrder.vue')
    }, {
      path: 'MallMessage',
      name: 'MallMessage', //系统消息
      component: () => import('../views/Mall/MallMessage.vue')
    }, {
      path: 'MallManager',
      name: 'MallManager', //商城主页
      component: () => import('../views/Mall/MallManager.vue')
    },
    {
      path: 'CarType',
      name: 'CarType', //车辆类型
      component: () => import('../views/SystemMall/CarType.vue')
    },
    {
      path: 'ItemType',
      name: 'ItemType', //商品类别
      component: () => import('../views/SystemMall/ItemType.vue')
    },
    {
      path: 'ParamySet',
      name: 'ParamySet', //参数设置
      component: () => import('../views/SystemMall/ParamySet.vue')
    },
    {
      path: 'ShopManage',
      name: 'ShopManage', //店铺管理
      component: () => import('../views/SystemMall/ShopManage.vue')
    },
  ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router

